import { clientSettings } from 'go-modules/models/common/client.settings';

type MediaVttTypeName = 'caption' | 'thumbnail';

interface MediaVttTypeShape {
	name: MediaVttTypeName;
}

interface MediaVttAttributes {
	id?: number;
	media_id: number;
	file?: string;
	media_url?: string;
	type?: MediaVttTypeShape | null;
	media_status?: string;
}

type MediaVttInstance = ng.resource.IResource<MediaVttAttributes> &
	MediaVttAttributes & {
		getId: () => number | undefined;
		isCaption: () => boolean;
		isThumbnail: () => boolean;
	};

type MediaVttResource = ng.resource.IResourceClass<MediaVttInstance> & {
	TYPE: {
		CAPTION: MediaVttTypeName;
		THUMBNAIL: MediaVttTypeName;
	};
	EXT: {
		VTT: '.vtt';
	};
	newInstance: (data?: Partial<MediaVttAttributes>) => MediaVttInstance;
	transformMediaToMediaVttCaption: (media: {
		filename?: string;
		media_id: number;
		media_url?: string;
		media_status?: string;
	}) => MediaVttInstance;
};

/* @ngInject */
export function MediaVTTFactory ($resource: ng.resource.IResourceService): MediaVttResource {
	const baseUrl = `${clientSettings.GoReactV2API}/media/:media_id/media_vtt/:id`;

	const MediaVTT = $resource(baseUrl, {
		id: '@id',
		media_id: '@media_id'
	}) as MediaVttResource;

	MediaVTT.TYPE = {
		CAPTION: 'caption',
		THUMBNAIL: 'thumbnail'
	};

	MediaVTT.EXT = {
		VTT: '.vtt'
	};

	MediaVTT.transformMediaToMediaVttCaption = (media) => {
		const mediaVtt: MediaVttAttributes = {
			file: media.filename,
			media_id: media.media_id,
			media_url: media.media_url,
			media_status: media.media_status,
			type: {
				name: MediaVTT.TYPE.CAPTION
			}
		};

		return MediaVTT.newInstance(mediaVtt);
	};

	MediaVTT.newInstance = function (data = {}) {
		return new MediaVTT(data);
	};

	MediaVTT.prototype.getId = function () {
		return this.id;
	};

	MediaVTT.prototype.isCaption = function () {
		return this.type?.name === MediaVTT.TYPE.CAPTION;
	};

	MediaVTT.prototype.isThumbnail = function () {
		return this.type?.name === MediaVTT.TYPE.THUMBNAIL;
	};

	return MediaVTT;
}
